export const SHAPE = {
  A: {
    path: 'M376 3.99992C229 -6.50006 165.5 17 1 1',
    height: 8,
  },
}
